module.exports = __webpack_public_path__ + "img/can3.0d1363ae.png";